<template lang="pug">
  div
    h4 <kbd>環境參數資訊</kbd> 
    vuetable(
      ref="vuetable"
      :api-url="`${server}/api/fixed-link-code/`"
      data-path=""
      pagination-path=""
      :per-page=20
      :fields="fields"
      :css="boostrapCss"
      :http-options="httpOptions"
      :append-params="moreParams" 
      detail-row-component="para-detail"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:cell-clicked="onCellClicked")
    vuetable-pagination(
      ref="pagination"
      @vuetable-pagination:change-page="onChangePage"
      :css="boostrapCss.pagination" 
    )
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination';
import { mapState } from 'vuex';
import Vuetable from 'vuetable-2/src/components/Vuetable';
import readCookie from '@/vuex/functions/readCookie';
import server from '@/config';
import ParaDetail from './ParaDetail';

Vue.component('para-detail', ParaDetail);

export default {
  name: 'ParaSettings',
  data() {
    return {
      boostrapCss: {
        tableClass: 'table table-striped table-sm',
        loadingClass: 'loading',
        ascendingIcon: 'glyphicon glyphicon-chevron-up',
        descendingIcon: 'glyphicon glyphicon-chevron-down',
        handleIcon: 'glyphicon glyphicon-menu-hamburger',
        pagination: {
          infoClass: '',
          wrapperClass: 'pagination',
          activeClass: 'page-active',
          disabledClass: 'disabled',
          pageClass: 'page-link',
          linkClass: 'page-link',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        },
      },
      httpOptions: {
        headers: {
          Authorization: `Token ${readCookie('Token')}`,
        },
      },
      server,
      fields: [
        {
          name: 'fixed_link_code',
          title: '固定桿代碼',
        },
        {
          name: 'location',
          title: '地點名稱',
        },
        {
          name: 'verInfo',
          title: '軟體版本/日期',
        },
        {
          name: 'location_code',
          title: '地點代碼',
        },
        {
          name: 'road_speed_limit',
          title: '道路限速',
        },
        {
          name: 'break_value',
          title: '舉發車速(超速)',
        },
        {
          name: 'break_value_slow',
          title: '舉發車速(龜速)',
        },
        {
          name: 'alarmSpeed',
          title: '警示違規車速',
        },
        {
          name: 'alarmIllegalNum',
          title: '警示違規筆數',
        },
      ],
      moreParams: undefined,
    };
  },
  components: {
    Vuetable,
    VuetablePagination,
  },
  methods: {
    onCellClicked(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.id);
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
  },
  // computed: mapState({
  //   system: state => state.system,
  // }),
};
</script>

<style lang="sass">

</style>




// WEBPACK FOOTER //
// ParaSettings.vue?228898f4